import JsxComponent from '@slickdeals/blueprint-twig/javascript/core/jsxComponent';
export const name = 'CashbackJoinModal';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-cashbackJoinModal";
})(ClassNames || (ClassNames = {}));
class CashbackJoinModal extends JsxComponent {
    constructor() {
        super(name);
    }
    /**
     * Creates the main welcome modal UI
     *
     * @returns HTMLDivElement
     */
    createElement() {
        return (JsxComponent.parseJsx("div", { className: "bp-p-cashbackJoinModal" },
            JsxComponent.parseJsx("div", { className: "bp-p-cashbackJoinModal_left" }),
            JsxComponent.parseJsx("div", { className: "bp-p-cashbackJoinModal_right" },
                JsxComponent.parseJsx("h3", { className: "bp-p-cashbackJoinModal_title" },
                    "Slickdeals Rewards \u2014",
                    JsxComponent.parseJsx("br", null),
                    "Easier than Ever."),
                JsxComponent.parseJsx("p", { className: "bp-p-cashbackJoinModal_subtitle" }, "Get paid to shop! Receive Cashback on deals when you shop on Slickdeals. No installs or sign ups required."),
                JsxComponent.parseJsx("button", { "data-role": "cashbackJoinModalButton", className: "bp-p-cashbackJoinModal_button" }, "Start Earning Cashback"),
                JsxComponent.parseJsx("div", { className: "bp-p-cashbackJoinModal_countdown" },
                    "closing in\u00A0",
                    JsxComponent.parseJsx("span", { className: "bp-p-cashbackJoinModal_countdownValue" }, "3"),
                    "..."))));
    }
}
export default CashbackJoinModal;
